/**
 * KAN-833: звонок менеджеру с соединением с клиентом (click-to-call).
 * Платформа сначала звонит менеджеру на его номер, после ответа соединяет с клиентом.
 *
 *   POST /api/v1/clients/{id}/manager-call/   - 202 {call_uuid, contact_id, manager_phone_masked}
 *                                                400 {detail}: причина отказа (нет номера менеджера,
 *                                                клиент просил не звонить, номер занят)
 * KAN-877: тело {target} - звонить ровно этому адресату (из GET call-targets);
 * без тела сервер выбирает адресата сам.
 */
import apiClient from './client';
import type { CallTargetKind } from './callTargets';

/** Ответ запуска звонка: номер менеджера замаскирован ("+7***12"). */
export interface ManagerCallStarted {
  call_uuid: string;
  contact_id: string;
  manager_phone_masked: string;
}

/** Путь запуска звонка (им же проверяется доступ менеджера). */
export function managerCallUrl(clientId: string): string {
  return `/api/v1/clients/${clientId}/manager-call/`;
}

export async function startManagerCall(clientId: string, target?: CallTargetKind): Promise<ManagerCallStarted> {
  const res = target
    ? await apiClient.post<ManagerCallStarted>(managerCallUrl(clientId), { target })
    : await apiClient.post<ManagerCallStarted>(managerCallUrl(clientId));
  return res.data;
}
